import React, { useContext, useState } from "react";

import {
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";

import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";
import Tabs from "../../../../components/tabs/TabsErp";

import {
  HeaderModal,
  ModalCartaCorrecaoNF,
  Body,
  FontButton,
} from "../styles/Emissao";

import TabCCNova from "./TabCCNova";
import TabCCHistorico from "./TabCCHistorico";
import useNfeController from "../controllers/NfeController";
import { PainelNfeContext } from "../contexts/PainelNfeContext";

const tabHeaders = [
  {
    label: "Nova C.C",
  },
  {
    label: "Histórico",
  },
];

const ModalCartaCorrecao = ({
  nfeId,
  modalCartaCorrecaoOpen,
  setModalCartaCorrecaoOpen,
  setMainLoading,
}) => {
  const tabContents = [<TabCCNova />, <TabCCHistorico nfeId={nfeId} />];

  const { ccDescription, setCCId, ccId } = useContext(PainelNfeContext);
  const { handleSaveCC, handleDownloadCartaCorrecao } = useNfeController();
  const [tabIndex, setTabIndex] = useState(0);

  const handleClose = () => {
    setCCId(null);
    setModalCartaCorrecaoOpen(false);
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      open={modalCartaCorrecaoOpen}
      onClose={handleClose}
      aria-labelledby="dialog-carta-correcao-nfe"
    >
      <ModalCartaCorrecaoNF>
        <HeaderModal>
          <DialogTitle id="dialog-carta-correcao-nfe">
            <Chip
              label="Carta de Correção da NFe"
              bgcolor="primary"
              textcolor="white"
            />
          </DialogTitle>
        </HeaderModal>
        <DialogContent>
          <Body>
            <Tabs
              headers={tabHeaders}
              children={tabContents}
              tabIndex={tabIndex}
              onChange={(event, value) => {
                if (Number.isInteger(value)) setTabIndex(value);
              }}
            />
          </Body>
        </DialogContent>
        <DialogActions>
          <FontButton>
            <Grid container spacing={2}>
              <Grid item xs />
              <Grid item>
                <Btn
                  bgcolor="tertiary"
                  hovercolor="darkred"
                  onClick={handleClose}
                  label="Cancelar"
                  full="true"
                />
              </Grid>
              <Grid item>
                <Btn
                  bgcolor="blue"
                  hovercolor="lightgreen"
                  onClick={() => {
                    handleDownloadCartaCorrecao(ccId, setMainLoading);
                  }}
                  label="Download PDF"
                  full="true"
                  disabled={!ccId}
                />
              </Grid>
              <Grid item>
                <Btn
                  label="Confirmar"
                  full="true"
                  onClick={() => {
                    handleSaveCC(nfeId, ccDescription, setMainLoading);
                  }}
                  disabled={tabIndex !== 0 ? true : false}
                />
              </Grid>
            </Grid>
          </FontButton>
        </DialogActions>
      </ModalCartaCorrecaoNF>
    </Dialog>
  );
};

export default ModalCartaCorrecao;
